import { defineComponent as _defineComponent } from 'vue'
import SIcon from '@/components/SIcon.vue';
import SButton from '@/components/SButton/SButton.vue';
import SHtmlView from '@/components/SHtmlView/SHtmlView.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SNotifications',
  setup(__props) {

const iconMap = {
  info: 'icon-info-circle-fill',
  error: 'icon-dismiss-circle-fill',
  warning: 'icon-warning-fill',
  success: 'icon-check-circle-fill',
  ai: 'icon-sparkles',
};

const iconColorMap = {
  // those are not the right colors, fix later
  info: 'iconNeutral',
  error: 'iconDanger',
  warning: 'iconWarning',
  success: 'iconSuccess',
  ai: 'iconAi',
};

const getIcon = (type: string) => iconMap[type as keyof typeof iconMap];

const iconColor = (type: string) => iconColorMap[type as keyof typeof iconColorMap] || iconColorMap.info;


return { __sfc: true,iconMap, iconColorMap, getIcon, iconColor, SIcon, SButton, SHtmlView }
}

})